<div>
  <ion-header translucent>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button fill="clear" class="ion-margin-top" tappable (click)="close()">
          <ion-icon color="primary" name="arrow-back">{{'COMPONENTS.MODALS.BACK' | translate}}</ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button fill="clear" class="ion-margin-top" tappable (click)="rotateRight()" color="primary">
          90°<ion-icon flex class="ion-align-self-center" color="primary" src="assets/svg/rotate-right.svg"></ion-icon>
        </ion-button>
        <ion-button fill="clear" class="ion-margin-top" tappable (click)="rotateLeft()" color="primary">
          90°<ion-icon flex class="ion-align-self-center" color="primary" src="assets/svg/rotate-left.svg"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title color="primary">{{'COMPONENTS.MODALS.ROTATE_CROP' | translate}}</ion-title>
    </ion-toolbar>
  </ion-header>
    <image-cropper [imageBase64]="image" [maintainAspectRatio]="false" [canvasRotation]="canvasRotation" format="jpeg"
    (imageCropped)="imageCropped($event)" class="max-100vh crop-bg height-100"></image-cropper>
  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button id="changeText" (click)="save()">
          <ion-icon slot="end" size="large" color="primary" src="assets/svg/checkmark.svg"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</div>
